import { api } from "../lib/api";

export interface ActivityEntry {
  id: string;
  at: string;
  action: string;
  invoice_id: string | null;
  invoice_number: string | null;
  client_name: string | null;
  amount: string | null;
  currency: string | null;
}

export interface Dashboard {
  outstanding_total: string;
  overdue_count: number;
  overdue_total: string;
  draft_count: number;
  ytd_invoiced: string;
  client_count: number;
  invoice_count: number;
  recent_activity: ActivityEntry[];
  vat_current_period_end: string | null;
  vat_estimated_box1: string | null;
  uncategorised_txn_count: number;
  /** Instance-wide backup freshness (09-backup-restore.md). `backup_last_at` is null when
   * no archive exists at all, which the server reports as stale, not unknown. */
  backup_last_at: string | null;
  backup_stale: boolean;
}

export function getDashboard(): Promise<Dashboard> {
  return api.get<Dashboard>("/api/dashboard");
}
